<script>
import Dfes from '@/components/Dfes.vue'
export default {
  components: {
    Dfes
  }
}
</script>

<template>
  <Dfes
   document="ctes"
   descriptionDocument="CTe (s)"
  />
</template>

<style>

</style>
